import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, signal } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { BlockableDiv } from '../../../../shared/controls/blockable-div/blockable-div.component';
import { BaseDetailComponent } from '../../../../common/base-detail.component';
import { Address } from '../../../../generated/generated-types';
import { DataProtectionWidgetComponent } from '../data-protection-widget/data-protection-widget.component';

@Component({
  selector: 'app-formly-address-data-protection-widget',
  templateUrl: './formly-address-data-protection-widget.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    ButtonModule,
    BlockableDiv,
    TooltipModule,
    DataProtectionWidgetComponent,
    TranslatePipe,
  ]
})
export class FormlyAddressDataProtectionWidgetComponent extends FieldType {

  private readonly cdRef = inject(ChangeDetectorRef);

  isSaving = signal(false);

  checkIfCanSave(): boolean {
    const component = this.options.formState.detailComponent as BaseDetailComponent<Address>;
    return component.detailForm.invalid;
  }

  async saveToUnlockEditMode(): Promise<void> {
    const component = this.options.formState.detailComponent as BaseDetailComponent<Address>;
    if (!component) {
      console.error('No detail component found to save address');
      return;
    }

    this.isSaving.set(true);
    this.cdRef.detectChanges();

    await component.save();

    this.isSaving.set(false);
    this.cdRef.detectChanges();
  }

}
